import { render, staticRenderFns } from "./SendWarehouse.vue?vue&type=template&id=2ac63e07&scoped=true"
import script from "./SendWarehouse.vue?vue&type=script&lang=js"
export * from "./SendWarehouse.vue?vue&type=script&lang=js"
import style0 from "./SendWarehouse.vue?vue&type=style&index=0&id=2ac63e07&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ac63e07",
  null
  
)

export default component.exports